import { TOAST_LIFE } from '@/utils/consts'
import { useToast } from 'primevue'

export interface MyToastOptions {
  severity?: string
  message?: string
  title?: string
  lifetime?: number | null
  summary?: string
  detail?: string
  life?: number | null
}
export const useMyToast = () => {
  const toast = useToast()
  const addToast = (options: MyToastOptions) => {
    toast.add({
      severity: options.severity,
      detail: options.detail ?? options.message,
      summary: options.summary ?? options.title,
      life: options.life ?? options.lifetime ?? TOAST_LIFE,
    })
  }
  return { addToast }
}
